function getMPImagePreview(url: string): string {
  const MP_adjustments = '/v1/fill/w_500,h_500,rf_22,al_c,lg_0/';
  const urlParts = url.split('/');
  const imageName = urlParts[urlParts.length - 1];

  return `https://images-${url.slice(8)}${MP_adjustments}${imageName}`;
}

export default getMPImagePreview;
